import hen from '../images/blogo.png'
// import resume from '../images/resume.svg'
import filelogo from '../images/filelogo.png'
import authenticate from '../images/laptop-security.png'
import apple from '../images/apple.svg'
import crime from '../images/crime.svg'
import tictactoe from '../images/tic-tac-toe.png'
import notes from '../images/notes.svg'
import dashboard from '../images/dashboard.svg'
import weather from '../images/weather.svg'
import tshirt from '../images/tshirt.svg'
import api from '../images/api.svg'
import calculator  from '../images/calculator.svg'
import form from '../images/form.svg';
import culinashare from '../images/culinashare_logo.png'

const ProjectData =[
  {
    title : 'CulinaShare',
    subheader :'Recipe Sharing Platform',
    image : culinashare,
    content : 'A web and mobile platform where users can post and share recipes,with anyone able to view these culinary guides',
    code : 'https://github.com/Sakthikarthick3107/CulinaShare-Recipe-Sharing',
    live : ''

  },
    {
      title : 'File Format Converter',
      subheader : 'For seamlessly convert and ensure file compatibility across all platforms with ease.',
      image : filelogo,
      content : 'The Universal File Format Converter is an innovative solution designed to effortlessly transform files between various formats, ensuring compatibility and easing the workflow for users across different platforms. ',
      code: 'https://github.com/Sakthikarthick3107/File-Format-Converter',
      live : 'https://file-format-converter.vercel.app/'
    },
    
    {
      title : 'Apple Products(E-commerce site)',
      subheader : 'A website for showcasing apple products',
      image : apple,
      content : 'An intermediate website for displaying,adding to cart and checkout features was developed using Vue Js , TailwindCss and Firebase',
      code: 'https://github.com/Sakthikarthick3107/apple-products-page',
      live : 'https://sakthikarthick-apple-products-page.vercel.app/'
    },
    {
      title : 'Chicken Shop',
      subheader : 'For advertising about our business through the Internet',
      image : hen,
      content : 'Website for my fathers chicken shop using html,css and js.',
      code: 'https://github.com/Sakthikarthick3107/sakthibroilers.github.io',
      live : "https://sakthibroilers.netlify.app"
    },
    {
      title : 'Online Crime Reporting System',
      subheader : 'A website application is for filing cases and view case status',
      image : crime,
      content : 'A complex application for online crime reporting system with React Js and Django backend for authentication,data storing and retrieving and displaying details at the frontend .',
      code: 'https://github.com/Sakthikarthick3107/crimeportal.github.io',
      live : ''
  },
  {
    title : 'Tic-tac-toe',
    subheader : 'Simple entertainment game',
    image : tictactoe,
    content : 'A simple tic-tac-toe game is developed  with simple logics by using React',
    code: 'https://github.com/Sakthikarthick3107/tic-tac-toe',
    live : 'https://sakthikarthicks-tic-tac-toe.vercel.app/'
  },
  {
    title : 'Authentication',
    subheader : 'Enhances security by authenticate every users with their user credentials',
    image : authenticate,
    content : 'Designed and developed a dynamic full-stack authentication page that combines security with creative designs and themes. ',
    code: 'https://github.com/Sakthikarthick3107/react-django-authentication',
    live : ''
  },
  {
    title : 'To-do-list',
    subheader : 'Simple tool for note down our daily tasks and summarize',
    image : notes,
    content : 'A simple to-do-list with neat user interfaces and features developed using React Native and Nativewind',
    code: 'https://github.com/Sakthikarthick3107/todo-mobile',
    live : 'https://expo.dev/artifacts/eas/rB9Tv7BKUqsXiEr6pMKRRu.apk'
  },
    {
      title : 'Dashboard Design',
      subheader : '',
      image : dashboard,
      content : 'Created a dashboard page for a task assigned by Daily Shopping using Next Js and Tailwind Css',
      code: 'https://github.com/Sakthikarthick3107/Dashboard.github.io',
      live : 'https://dashboard-github-io-nhe5.vercel.app/'
    },
   
  
  
  ]
export default ProjectData